export enum ShiftEnum {
  Parcial = 1,
  Integral = 2
}
